import OftecCd11ServicingCommissioningForm from './OftecCd11ServicingCommissioningForm';
import OftecCd11ServicingCommissioningPDF from './OftecCd11ServicingCommissioningPDF';
import schema from './schema';
import validator from './validator';
import defaultData from './defaultData';
import { transformForPDF } from './transform';

export default {
  Form: OftecCd11ServicingCommissioningForm,
  PDF: OftecCd11ServicingCommissioningPDF,
  schema,
  validator,
  defaultData,
  transform: transformForPDF
};
